<template>
<div>
    <div class="freddies-shop-header">
        <h2>{{ $t('GIFT_SHOP_EXTRA_SPECIAL') }}</h2>
    </div>
    <div class="background--paper">
        <div class="freddies-shop">
            <div class="divider-white--top"></div>
            <div class="shop">
                <div class="shop__product-container">
                    <div class='shop__product-block text-center' v-for="(item, key) in filteredProducts" :key="key">
                        <div  @click="selectProduct(item)">
                            <product-card :item="item" :allowNavigation="false"/>
                        </div>
                        <button class="btn btn--primary select-button" @click="addProduct(item, 1)">{{$t('GIFTING_SHOP_ADD_BUTTON')}}</button>
                    </div>
                </div>
            </div>
            <div class="freddies-shop-summary">
                <h2>{{ $t('GIFT_SHOP_ORDER_SUMMARY') }}</h2>
                <div class="freddies-shop-summary-items">
                    <div class="freddies-shop-summary-item" v-for="(item, key) in additionalProducts" :key="`${key}`">
                        <img :src="item.images.main.thumbnail" />
                        <div class="freddies-shop-summary-item-info">
                            <p><strong>{{item.title}}</strong></p>
                            <p>{{item.quantity}} x {{currency}}{{item.price}}</p>
                            <button class="order-summary__detail text-left mt-1 underline block" @click="removeProduct(item.productId)">{{$t('GIFTING_SHOP_REMOVE_BUTTON')}}</button>
                            <hr class="divider" />
                        </div>
                    </div>
                    <div class="freddies-shop-summary-item" v-if="freeVase && !isPopMultiSelected">
                        <img :src="freeVase.images.main.thumbnail" />
                        <div class="freddies-shop-summary-item-info">
                            <p><strong>{{freeVase.title}}</strong></p>
                            <div  class="order-summary__detail__price">
                                <p>{{freeVase.quantity}} x <span class="line-through">{{currency}}{{freeVase.price}}</span></p>
                                <p><b>{{$t('SHOP_FREE')}}</b></p>
                            </div>
                            <hr class="divider" />
                        </div>
                    </div>
                </div>

                <div class="freddies-shop-summary-total">
                    <div class="order-summary__summary__costs">
                        <p class="order-summary__detail" v-text="priceDetailsText"></p>
                        <div class="order-summary__detail__price">
                            <p class="order-summary__detail" :class="{'line-through': discountedPrice < totalPrice}" v-text="currency + totalPrice"></p>
                            <p v-if="discountedPrice < totalPrice" class="order-summary__detail" v-text="currency + discountedPrice"></p>
                        </div>
                    </div>
                    <div class="order-summary__summary__costs">
                        <p class="order-summary__detail" v-text="$t('SHOP_DELIVERY')"></p>
                        <p class="order-summary__detail" v-text="$t('SHOP_FREE')"></p>
                    </div>
                    <div class="order-summary__summary__costs">
                        <p class="order-summary__detail" v-text="$t('GIFTING_SHOP_EXTRA')"></p>
                        <p class="order-summary__detail extra_text" v-text="`${currency}${additionalProductsCost}`"></p>
                    </div>
                    <div class="order-summary__summary__costs">
                        <p class="order-summary__detail__total" v-text="$t('SHOP_TOTAL')"></p>
                        <p class="order-summary__detail__total" v-text="`${currency}${total}`"></p>
                    </div>
                </div>

                <button class="btn btn--primary next-button btn--auto-width" @click="submit" v-html="$t('FREDDIES_ADDONS_NEXT')"></button>
            </div>
            <div class="divider-white--bottom"></div>
        </div>
    </div>
    <product-modal v-if="selectedProduct" :item="selectedProduct" @close="closeModal()" @addProduct="addProduct"/>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { CSPageEvents } from '@/helpers/GAHelpers';
import { GIFT_TYPE_ONE_OFF, PRODUCT_FAMILY_BUMPER, PRODUCT_FAMILY_STANDARD, SECTION_FREDDIES_SHOP, PRODUCT_TYPE_SINGLE, PRODUCT_TYPE_BUMPER_SINGLE, PRODUCT_TYPE_MULTI, PRODUCT_TYPE_BUMPER_MULTI, DISPLAY_NAME_BUMPER, PRODUCT_TYPE_POP_SINGLE, PRODUCT_TYPE_POP_MULTI } from '@/constants/Gifting';
import { turnScrollOff, turnScrollOn } from '@/helpers/ScrollHelpers.js';
import ProductCard from '@/components/partials/account/shop/ProductCard';
import ProductModal from '@/components/partials/account/shop/product-details/ProductModal';

export default {
    name: 'FreddiesShop',
    components: {
        ProductCard,
        ProductModal,
    },
    created() {
        const deliveryType = this.deliveryType === GIFT_TYPE_ONE_OFF ? 'single_gifting' : 'multi_gifting';
        this.$store.dispatch('shop/fetchProducts', { active_in: deliveryType });
        this.selectedProducts = this.additionalProducts;
    },
    mounted() {
        this.$store.dispatch('gifting/fetchPrices');
        this.$store.dispatch('gifting/fetchGiftingCoupons');
    },
    computed: {
        ...mapGetters({
            products: 'shop/getProducts',
            currency: 'localisation/getCurrency',
            additionalProducts: 'gifting/getAdditionalProducts',
            additionalProductsCost: 'gifting/getAdditionalProductsTotalCost',
            deliveryType: 'gifting/getDeliveryType',
            totalPrice: 'gifting/getTotalPriceForDeliveries',
            totalDeliveries: 'gifting/getNumberOfDeliveriesForSubscription',
            selectedBoxName: 'gifting/getSelectedBoxName',
            oneOffGiftPrice: 'gifting/getPricePerOneOffDelivery',
            multipleDeliveriesPrice: 'gifting/getPricePerSubscriptionDelivery',
            bumperBoxPrice: 'gifting/getPricePerOneOffBumperDelivery',
            subscriptionBumperPrice: 'gifting/getPricePerSubscriptionBumperDelivery',
            singleCoupon: 'gifting/getSingleGiftCoupon',
            multiCoupon: 'gifting/getMultiGiftCoupon',
            isSubscription: 'gifting/isSubscription',
            specialDatesCoupon: 'gifting/getSpecialDatesGiftCoupon',
            isFreeVase: 'account/isFreeVase',
            defaultProductFamily: 'register/getDefaultProductFamily',
        }),
        total() {
            return Number(this.discountedPrice) + Number(this.additionalProductsCost);
        },
        freeVase() {
            if (this.isPopSelected) return;
            let vaseName;
            let vase;
            if (!this.isSubscription && this.isFreeVase) {
                vaseName = this.selectedBoxName === PRODUCT_TYPE_BUMPER_SINGLE ? this.$t('FREDDIES_SHOWSTOPPER_VASE') : this.$t('CLASSIC_VASE');
                vase = this.products.find(product => product.title === vaseName);
            }
            if (this.isSubscription) {
                vaseName = this.selectedBoxName === PRODUCT_TYPE_BUMPER_MULTI ? this.$t('FREDDIES_SHOWSTOPPER_VASE') : this.$t('CLASSIC_VASE');
                vase = this.products.find(product => product.title === vaseName);
            }
            if (vase) vase.quantity = 1;
            return vase;
        },
        isPopSelected() {
            return this.selectedBoxName === PRODUCT_TYPE_POP_SINGLE;
        },
        isPopMultiSelected() {
            return this.selectedBoxName === PRODUCT_TYPE_POP_MULTI;
        },
        isPopCoupon() {
            return this.isPopSelected || this.isPopMultiSelected;
        },
        discountedPrice() {
            const saving = this.calculateDiscountAmount();
            const price = this.totalPrice - saving;
            return price;
        },
        pricePerOneOffDelivery() {
            let price = this.$store.getters['gifting/getPricePerOneOffDelivery'];

            return parseInt(price || 0);
        },
        priceDetailsText() {
            switch (this.selectedBoxName) {
            case PRODUCT_TYPE_POP_SINGLE: return this.$t('SHOP_ORDER_SUMMARY_BOX', { numOfBoxes: this.totalDeliveries });
            case PRODUCT_TYPE_SINGLE: return this.$t('SHOP_ORDER_SUMMARY_BOX', { numOfBoxes: this.totalDeliveries });
            case PRODUCT_TYPE_MULTI: return this.$t('SHOP_ORDER_SUMMARY_BOXES', { numOfBoxes: this.totalDeliveries });
            case PRODUCT_TYPE_POP_MULTI: return this.$t('SHOP_ORDER_SUMMARY_BOXES', { numOfBoxes: this.totalDeliveries });
            case PRODUCT_TYPE_BUMPER_SINGLE: return this.$t('SHOP_ORDER_BUMPER_BOX', { numOfBoxes: this.totalDeliveries, theBox: DISPLAY_NAME_BUMPER });
            case PRODUCT_TYPE_BUMPER_MULTI: return this.$t('SHOP_ORDER_BUMPER_BOXES', { numOfBoxes: this.totalDeliveries, theBox: DISPLAY_NAME_BUMPER });
            }
        },
        filteredProducts() {
            return this.products?.filter(product => product.title !== this.freeVase?.title);
        },
    },
    data() {
        return {
            selectedProduct: null,
            selectedProducts: [],
        };
    },
    methods: {
        couponDiscountValue(coupon) {
            if (coupon?.discountType === 'percentage') {
                return this.totalPrice * (coupon?.discount / 100);
            } else if (coupon?.discountType === 'amount') {
                return coupon?.discount * 0.01;
            }
            return 0;
        },
        calculateDiscountAmount() {
            let currentCoupon;
            if (this.specialDatesCoupon && this.isPopCoupon) {
                currentCoupon = this.specialDatesCoupon;
            } else {
                currentCoupon = this.isSubscription ? this.multiCoupon : this.singleCoupon;
            }
            if (this.specialDatesCoupon && this.couponDiscountValue(currentCoupon) <= this.couponDiscountValue(this.specialDatesCoupon)) {
                currentCoupon = this.specialDatesCoupon;
            } else {
                if ((this.selectedBoxName === PRODUCT_TYPE_BUMPER_MULTI || this.selectedBoxName === PRODUCT_TYPE_BUMPER_SINGLE) &&
                    !currentCoupon?.product_families.includes(PRODUCT_FAMILY_BUMPER)) {
                    return 0;
                }
                if ((this.selectedBoxName === PRODUCT_TYPE_MULTI || this.selectedBoxName === PRODUCT_TYPE_SINGLE) &&
                    !currentCoupon?.product_families.includes(PRODUCT_FAMILY_STANDARD)) {
                    if (currentCoupon?.product_families.length) return 0;
                }
            }

            if ((this.specialDatesCoupon && this.isPopCoupon) || !this.isPopCoupon) {
                const discountType = currentCoupon?.discountType;
                const discountValue = currentCoupon?.discount;

                if (discountType === 'percentage') {
                    const saving = this.totalPrice * (discountValue / 100);
                    return saving.toFixed(2);
                } else if (discountType === 'amount') {
                    const saving = discountValue * 0.01;
                    return saving.toFixed(2);
                }
            }
            return 0;
        },
        submit() {
            this.$store.commit('gifting/setSectionComplete', SECTION_FREDDIES_SHOP);
            this.$router.push({ name: 'account.gifting.delivery-day' });
            CSPageEvents('giftOneOff', {
                productType: 'gift',
                productFamily: this.selectedBoxName || this.defaultProductFamily,
                frequency: 'once',
            });
        },
        closeModal() {
            this.selectedProduct = null;
            turnScrollOn(document);
        },
        selectProduct(item) {
            this.selectedProduct = item;
            turnScrollOff(document);
        },
        addProduct(payload, quantity = null) {
            if (this.selectedProducts.includes(payload)) {
                if (payload.quantity < 5) payload.quantity++;
            } else {
                payload.quantity = 1;
                this.selectedProducts.unshift(payload);
            }
            this.updateStore();
            this.closeModal();
        },
        removeProduct(id) {
            let index = this.selectedProducts.findIndex(product => product.productId === id);
            if (this.selectedProducts[index].quantity > 1) this.selectedProducts[index].quantity--;
            else this.selectedProducts.splice(index, 1);

            // delete this.selectedProducts[id];
            this.updateStore();
        },
        updateStore() {
            this.$store.commit('gifting/updateProducts', this.selectedProducts);
            this.$store.commit('gifting/updateProductsTotalCost');
        },
    },
    beforeDestroy() {
        this.closeModal();
    },
};
</script>

<style scoped lang="scss">
    .freddies-shop-header {
        text-align: center;
    }
    .freddies-shop {
        display: flex;
        margin: 0 auto;
        width: 70%;
        align-items: flex-start;
        flex-wrap: wrap;
        gap: 50px;

        .btn.select-button {
            margin-top: 10px;
            padding: 6px;
            min-width: 100px;
        }

        @media (max-width: 1700px) {
            width: 90%;
        }

        @media (max-width: 999px) {
            gap: 0px;
        }

        .divider-white--top {
            top: unset;
        }
        .divider-white--bottom {
            bottom: 0;
        }

        &-summary {
            max-width: 350px;
            margin: 25px auto;
            flex: 1 auto;
            text-align: center;
            padding: 20px;
            border: 1px solid black;
            background-color: white;

            @media (max-width: 999px) {
                max-width: 500px;
            }

            &-items {
                max-height: 300px;
                overflow-y: scroll;
            }

            &-item {
                margin-top: 35px;
                display: inline-flex;
                width: 100%;
                gap: 30px;

                img {
                    width: 95px;
                    height: 125px;
                }

                &-info {
                    text-align: left;
                }

                .divider {
                    margin-top: 30px;
                }
            }

            &-total {
                width: 300px;
                margin: 20px auto;
            }

            .next-button {
                margin-top: 20px;
                padding: 10px 15px;
            }
        }

        .shop {
            max-width: 900px;
            margin: 25px auto;
            padding: 25px;
            flex: 1 auto;

            @media (max-width: 1302px) {
                max-width: 500px;
            }
        }
    }
    .order-summary__detail__price {
        display: flex;
        gap: 10px;
    }
    .line-through {
        text-decoration: line-through;
    }
</style>
